import Clickable from '/components/Clickable';
import Icon from '/components/IconUpdated';
import PropTypes from 'prop-types';
import SizeGuide from '/components/size-guides/SizeGuide';
import Typography from '/components/Typography';
import classNames from '/utils/class-names';
import { useWizard } from 'react-use-wizard';
import { Accordion, AccordionItem, AccordionPanel } from '/components/Accordion';
import { useEffect, useState } from 'react';

const SizeStep = ({
	builderConfig,
	hideContinueButton = false,
	packConfig,
	updatePackProductConfig,
}) => {
	const [productConfig, setProductConfig] = useState({});

	const { nextStep } = useWizard();

	useEffect(() => {
		setProductConfig(packConfig?.productConfigs?.[packConfig.currentProductConfigIndex] || {});
	}, [packConfig]);

	const continueWizard = () => {
		nextStep();
	};

	const updateProductConfig = (key, value) => {
		const toUpdate = { ...productConfig };
		toUpdate[key] = value;
		setProductConfig(toUpdate);

		updatePackProductConfig(packConfig.currentProductConfigIndex, key, value);
	};

	const selectedStyle = builderConfig?.styles?.find((style) => style?.id === builderConfig?.id);

	if (!productConfig?.productType?.sizes || productConfig.productType.sizes.length < 1) {
		return null;
	}

	return (
		<div className="max-w-xl mx-4 md:m-auto text-center">
			<Typography variant="subhead-md">{builderConfig.sizeDescription}</Typography>
			<div className="flex justify-center mb-4 md:mb-6">
				<Icon name="sparkle" height="16px" width="16px" />
				<Typography className="-ml-[1px] mt-1" variant="small">
					Tip: If you&apos;re between sizes or prefer a more supportive fit, size down.
				</Typography>
			</div>

			<div className="flex flex-wrap gap-3 max-w-sm m-auto items-center align-middle justify-center">
				{productConfig.productType.sizes.map((size, i) => {
					return (
						<Clickable
							onClick={() => updateProductConfig('size', size)}
							key={i}
							className={classNames(
								'p-4 rounded-md h-[80px] min-w-[80px]',
								productConfig.size === size
									? 'bg-v2-brown-darker text-white'
									: 'border-2 border-v2-brown-darker',
							)}>
							<Typography variant="heading-sm">
								{selectedStyle?.sizeRenames?.[productConfig?.productType?.productType]?.[size] ||
									size}
							</Typography>
						</Clickable>
					);
				})}
			</div>

			{/* TODO (PACK BUILDER): Disable if no size */}
			{hideContinueButton === false && (
				<div>
					<Clickable
						variant="filled"
						disabled={!productConfig.size}
						className="px-4 my-2 py-2 font-semibold border-2 border-primary hover:border-primary-dark w-full md:w-auto rounded-md"
						onClick={() => {
							continueWizard();
						}}>
						Continue to Prints
					</Clickable>
				</div>
			)}

			{packConfig.productConfigs?.[packConfig.currentProductConfigIndex]?.productType
				?.styleNumber && (
				<div className="border-[3px] border-gray-600 my-4 md:mt-12 rounded-[14px]">
					<Accordion>
						<AccordionItem>
							<Typography variant="heading-xs">Size Guide</Typography>
						</AccordionItem>
						<AccordionPanel>
							<div className="p-4">
								<SizeGuide
									styleNumber={
										packConfig.productConfigs?.[packConfig.currentProductConfigIndex]?.productType
											?.styleNumber
									}
									modal={false}
								/>
							</div>
						</AccordionPanel>
					</Accordion>
				</div>
			)}
		</div>
	);
};

SizeStep.propTypes = {
	builderConfig: PropTypes.object,
	hideContinueButton: PropTypes.bool,
	packConfig: PropTypes.object,
	selectedStyleId: PropTypes.string,
	updatePackProductConfig: PropTypes.func,
};

export default SizeStep;
